<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#app-layout {
        div.show-filters {
            height: 90px;
            width: 23px;
            position: absolute;
            left: 0px;
            background-color: white;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            line-height: 90px;
            top: 50%;
            cursor: pointer;
            margin-top: -45px;
            z-index: 9;
            text-align: center;
        }

        .fade-enter-active, .fade-leave-active {
            transition: opacity .2s;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }
    }

    nav.top-navigation {
        background-color: #FFFFFF;
        height: 75px;
        box-shadow: 0 2px 4px 0 rgba(3, 27, 78, 0.1);
        z-index: 9999;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;

        a.filters {
            cursor: pointer;
            color: $secondary-color;
            width: 150px;
            height: 45px;
            border: 2px solid $secondary-color;
            border-radius: 5px;
            //text-transform: uppercase;
            display: block;
            float: left;
            text-align: center;
            line-height: 41px;
            margin-top: 15px;
            margin-left: 20px;
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            font-size: 16px;

            img {
                display: inline-block;
                vertical-align: middle;
                margin-top: -3px;
                margin-right: 10px;
                height: 13px;
            }

            img.chevron-active {
                display: none;
            }

            &.active {
                background-color: $secondary-color;
                color: white;

                img.chevron {
                    display: none;
                }

                img.chevron-active {
                    display: inline-block;
                }
            }
        }

        div.logo-current-type-block {
            flex-wrap: wrap;
        }

        div.current-type-block {
            a {
                span {
                    color: $secondary-color;
                    font-family: 'Raleway', sans-serif;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }

        span.clear-filters {
            font-size: 16px;
            color: $text-secondary-color;
            font-family: 'Raleway', sans-serif;
            cursor: pointer;
            margin-left: 15px;
            display: block;
            float: left;
            margin-top: 25px;

            img {
                margin-right: 10px;
                float: left;
                margin-top: 6px;
            }
        }

        img.logo {
            margin: auto;
            margin-top: 26.5px;
            margin-bottom: 26.5px;
            width: 181px;
            display: block;
        }

        img.hamburger {
            display: none;
            float: right;
            margin-right: 18px;
            margin-top: 30px;
            cursor: pointer;
        }

        &:after{
            content: "";
            display: table;
            clear: both;
        }

        span.logout {
            font-family: 'Raleway', sans-serif;
            font-size: 16px;
            color: black;
            font-weight: bold;
            float: right;
            margin-top: 27px;
            margin-right: 10px;
            cursor: pointer;

            &:hover {
                color: $secondary-color;
            }
        }

        div.license-plate-container-view {
            width: 120px;
            float: right;
            margin-top: 26px;
            margin-right: 10px;
        }

        span.license-plate-view {
            color: #333333;
            background-color: #ffffff;
            background-image: url('/img/license-plate/cz.png');
            background-size: 11.5px;
            background-repeat: no-repeat;
            font-family: 'Raleway', sans-serif;
            font-size: 18px;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            padding-left: 20px;
            padding-right: 10px;
            width: 120px;
            height: 50px;
            border: 2px solid #333333;
            border-radius: 5px;
            outline: none;
        }

        span.development-label {
            font-family: 'Raleway', sans-serif;
            font-size: 16px;
            color: #fff;
            background-color: #dc3545;
            padding: 0.25rem 0.875rem;
            border-radius: 5px;
            font-weight: bold;
            float: left;
            margin-top: 22px;
            margin-left: 10px;
        }
    }

    div#app-layout {
        .fade-enter-active, .fade-leave-active {
            transition: opacity .2s;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }
    }

    div.cookie-container {
        margin-top: 100px;
        margin-bottom: 100px;

        h1 {
            font-size: 2rem;
        }

        h2 {
            font-size: 1.25rem;
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        nav.top-navigation {
            a.filters {
                font-size: 14px;
                line-height: 31px;
                margin-top: 20px;
                width: 85px;
                height: 35px;

                img {
                    display: none;
                }

                &.active {
                    img.chevron-active {
                        display: none;
                    }
                }
            }

            div.current-type-block {
                a {
                    span {
                        font-size: 12px;
                    }
                }
            }

            img.logo {
                margin-top: 29.5px;
                margin-bottom: 29.5px;
                width: 150px;
            }

            span.clear-filters {
                display: none;
            }

            div.license-plate-container-view {
                display: none;
            }

            div.language-switch-container-view {
                display: none;
            }

            span.logout {
                display: none;
            }

            span.development-label {
                display: none;
            }

            img.hamburger {
                display: block;
                margin-top: 26px;
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {
        nav.top-navigation {
            span.clear-filters {
                display: none;
            }

            div.license-plate-container-view {
                display: none;
            }

            div.language-switch-container-view {
                display: none;
            }

            span.logout {
                display: none;
            }

            span.development-label {
                display: none;
            }

            img.hamburger {
                display: block;
            }
        }
    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }
</style>

<template>
    <div id="app-layout">
        <div class="show-filters" v-show="( !showFilters )" v-on:click="toggleShowFilters()">
            <img src="/img/grey-right.svg"/>
        </div>

        <transition name="fade">
            <flash-message v-show="flashMessage"/>
        </transition>

        <nav class="top-navigation">
            <div class="grid-x">
                <div class="large-5 medium-5 small-4 cell">
                    <span class="development-label" v-if="app_env == 'local' || app_env == 'development'">
                        Testovací prostředí
                    </span>

                    <a class="filters" v-bind:class="{'active': showFilters}" v-on:click="toggleShowFilters()">
                        <img class="chevron" src="/img/chevron-right.svg"/>
                        <img class="chevron-active" src="/img/chevron-right-active.svg"/> {{ $t('filter.showChargingStationFiltersButton') }}
                    </a>
                </div>

                <div class="large-2 medium-2 small-4 cell">
                    <div class="logo-current-type-block flex-container flex-dir-column align-center-middle">
                        <router-link :to="{ name: 'charging-stations' }">
                            <img src="/img/logo-navigation-drivalia.svg" class="logo" alt="Drivalia" />
                        </router-link>

                        <!--
                        <div class="current-type-block">
                            <a v-on:click="changeServiceType()">
                                <span>{{ $t('servicetype.chargingStation') }}</span>
                            </a>
                        </div>
                        -->
                    </div>
                </div>

                <div class="large-5 medium-5 small-4 cell">
                    <img class="hamburger" src="/img/hamburger.svg" v-on:click="setShowPopOut()"/>
                    <div class="language-switch-container-view">
                        <lang-switcher />
                    </div>
                    <span class="logout" v-on:click="logout()">{{ $t('auth.logoutButton') }}</span>

                    <div class="license-plate-container-view" v-if="licensePlate">
                        <span class="license-plate-view">{{ licensePlate }}</span>
                    </div>
                </div>
            </div>
        </nav>

        <charging-station-filters></charging-station-filters>

        <div id="charging-station" class="page">
            <fullscreen-loader v-show="chargingStationsLoadStatus == 1"></fullscreen-loader>

            <charging-station-map></charging-station-map>

            <router-view></router-view>

            <charging-station-legend></charging-station-legend>

            <switch-type-modal></switch-type-modal>

            <pop-out></pop-out>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import FullscreenLoader from "../components/global/FullscreenLoader";
    import FlashMessage from '../components/global/FlashMessage.vue'
    import LangSwitcher from "../components/global/LangSwitcher.vue";
    import ChargingStationMap from '../components/services/ChargingStationMap.vue';
    import ChargingStationLegend from '../components/services/ChargingStationLegend.vue';
    import ChargingStationFilters from '../components/global/ChargingStationFilters.vue';
    import Geocode from "../api/geocode";
    import {ROAST_CONFIG} from "../config";
    import API from "../api/service";
    import {EventBus} from "../event-bus";
    import SwitchTypeModal from "../components/global/SwitchTypeModal.vue";
    import PopOut from "../components/global/PopOut.vue";

    export default {
        components: {
            PopOut,
            SwitchTypeModal,
            FullscreenLoader,
            FlashMessage,
            LangSwitcher,
            ChargingStationMap,
            ChargingStationLegend,
            ChargingStationFilters
        },

        data() {
            return {
                app_env: ROAST_CONFIG.APP_ENV,
            }
        },

        computed: {
            ...mapState({
                flashMessage: state => state.flashMessage.data.show
            }),

            licensePlate() {
                return this.$store.getters.getLicensePlate;
            },

            showFilters() {
                return this.$store.getters.getShowFilters;
            },

            chargingStationsLoadStatus() {
                return this.$store.getters.getChargingStationsLoadStatus;
            },

            activeMinimumPowerFilter() {
                return this.$store.getters.getMinimumPowerFilter;
            },
        },

        created() {
            document.title = this.$t('servicetype.chargingStation') + ' | Drivalia';

            if (!this.activeMinimumPowerFilter) {
                this.$store.commit('setMinimumPowerFilter', 'all');
            }

            if (this.$router.currentRoute.name == 'charging-station') {
                this.$store.dispatch('loadChargingStations', {
                    minimumPower: this.activeMinimumPowerFilter
                });
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.setClientLocationAndLoadChargingStations(position);
                    }, err => {
                        this.$store.dispatch('loadChargingStations', {
                            minimumPower: this.activeMinimumPowerFilter
                        });

                        console.log('User denied Geolocation');
                    }, {
                        enableHighAccuracy: true,
                        timeout: 60000
                    });
                }
            }
        },

        mounted() {

        },

        methods: {
            setClientLocationAndLoadChargingStations(position) {
                Geocode.getCountryCodeFromPosition(position)
                    .then((response) => {
                        if (response != 'CZ') {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: 50.08804, longitude: 14.42076 } })
                        } else {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: position.coords.latitude, longitude: position.coords.longitude } })
                        }

                        this.$store.dispatch('loadChargingStations', {
                            minimumPower: this.activeMinimumPowerFilter
                        });
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            },

            changeServiceType() {
                if (this.licensePlate) {
                    API.postAuthorize(this.licensePlate)
                        .then((response) => {
                            if (response.status === 200) {
                                EventBus.$emit('prompt-switch-type', response);
                            }
                        })
                        .catch((error) => {
                            this.logout();

                            this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('auth.errorMessageLogin') }, { root: true })
                        });
                } else {
                    localStorage.clear();

                    this.$router.replace({ name: 'login' });

                    window.location.reload();
                }
            },

            logout() {
                this.$store.dispatch('logoutClient').then(() => {}, () => {}).finally(() => {
                    localStorage.clear();

                    this.$store.commit('setDistanceFilter', 10);
                    this.$store.commit('setClientCurrentLocation', '');
                    this.$store.commit('setServices', []);
                    this.$store.commit('setLicensePlate', null);
                    this.$store.commit('setClientPersonalData', null);

                    this.$router.replace({ name: 'login' });

                    window.location.reload();
                });
            },

            toggleShowFilters() {
                this.$store.dispatch('toggleShowFilters', {
                    showFilters : !this.showFilters
                });
            },

            setShowPopOut() {
                this.$store.dispatch('toggleShowPopOut', {
                    showPopOut: true
                });
            }
        }
    }
</script>
